<template>
  <svg
    role="presentation"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M35.13 51.1321C33.853 52.8408 42.3531 75.5013 44.4751 75.662C47.6044 75.8991 65.376 63.7421 64.9939 61.7717C64.6249 59.8682 53.1109 57.8092 49.5018 56.5563C43.6597 54.5282 35.6031 50.4992 35.13 51.1321Z"
      fill="#F4EB84"
    />
    <path
      d="M52.8826 58.1634C52.8826 58.1634 63.5923 60.5313 63.3345 61.6337C63.0669 62.7783 45.6556 75.1407 43.8121 75.149C41.508 75.1593 33.4865 52.6629 35.5482 52.1326C37.61 51.6024 46.3171 57.9701 48.6862 55.9255C48.6862 55.9255 62.1586 40.7957 59.9463 24"
      stroke="#020D03"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
